import axiosInstance from "./AxiosInstance";

// Website API calls, named after the existing ocagian /api/v4 routes. They are called without an
// `auth` header, which the API treats as a guest; it still needs a `language` header.
const LANGUAGE_ID = 1;
const headers = {language: LANGUAGE_ID};

// Every box, open or not, each with a booking_status: open, closed, upcoming or ended.
export function getWebsiteLocations() {
    return axiosInstance.get(`website-location-list`, {headers});
}

// Contact details and social links from the admin Settings page.
export function getSettings() {
    return axiosInstance.get(`settings`, {headers});
}

// Contact form on the website: {name, email, topic, message}. Invalid input gives a 422 with `errors`.
export function sendWebsiteContact(data) {
    return axiosInstance.post(`website-contact`, data, {headers});
}

// Newsletter sign-up on the website: {email}. An invalid email gives a 422 with `errors`.
export function subscribeNewsletter(data) {
    return axiosInstance.post(`website-subscribe`, data, {headers});
}
